<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/12/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-1.png"
            alt=""
          />
          <div class="content">
            税收和相关经济数据统计关系在锦江区的创新平台，且创业平台线下入驻企业中锦江区企业占比不低于85%。
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/12/title-2.png"
            alt=""
          />
          <div class="content">
            创业平台获得市级及以上科技主管部门认定。
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/12/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）创业平台获得市级众创空间认定，给予15万元一次性补助；获得市级科技孵化器认定，给予25万元一次性补助；获得市级科技创业加速器认定，给予50万元一次性补助；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）创业平台获得省级众创空间认定，给予20万元一次性补助；获得省级科技孵化器认定，给予50万元一次性补助；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）创业平台获得国家级众创空间认定，给予25万元一次性补助；获得国家级科技孵化器认定，给予75万元一次性补助。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-4.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区支持青年创业平台建设补助申请表》；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申请企业统一社会信用代码证复印件，年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）市级及以上创业平台认定申报材料；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （四）市级及以上认定有关证明材料；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （五）其他需要提供的材料。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="font-weight: 600">
            符合条件的企业向属地街道提交申报材料
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86959072">028-86959072</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              锦江区科技局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.1rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
